<template>
  <div class="container live">
    <TeenWelcomeBar style="padding: 0;"/>
    <div class="tags">
      <div :class="['tag', active == item.value ? 'active' : '']" v-for="(item, index) in displayTagList" :key="item + index"
        @click="checkTag(item.value)">
        {{ item.text }}
      </div>
    </div>
    <div class="live-content">
      <div class="live-div" v-for="(item, index) in selectList" :key="index + 'live'" @mouseover="showPlay = item"
        @mouseout="showPlay = ''" @click="goLive(item)">
        <div class="img">
          <img :src="item.cover" />
          <div class="over-div" v-show="showPlay == item">
            <img src="../assets/img/play.png" />
          </div>
        </div>
        <div class="live-text">
          <div class="name">{{ item.title }}</div>
          <div class="num">
            <img src="../assets/img/people.png" />
            {{ item.num }}
          </div>
        </div>
      </div>
    </div>
    <Page :total="pageTotal" style="margin:auto;text-align:center;margin-bottom:40px" @on-change="handlePage"
      v-if="pageTotal > 0" :current="current" :page-size="size" show-elevator />

  </div>
</template>
<style lang="scss" scoped>
.live {
  height: 100%;
  overflow: hidden;
}

.tags {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  padding: 20px 0;

  .tags-tit {
    width: 96px;
    height: 34px;
    font-size: 24px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 34px;
    width: auto;
    margin-right: 20px;
  }

  .tag {
    background-color: #ffffff;
    border-radius: 12px;
    border: 1px solid #e2e2e2;
    padding: 3px 10px;
    width: auto;
    display: inline-block;
    margin-right: 10px;
    font-size: 12px;
    cursor: pointer;
    margin-bottom: 8px;
  }

  .active {
    color: #20a0ff;
    border: 1px solid #20a0ff;
  }
}

.live-content {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  margin-bottom: 40px;
  gap: 15px;

  .live-div {
    width: calc((100% - 30px) / 3);
    min-width: 140px;
    height: auto;
    background: #ffffff;
    border-radius: 4px;
    position: relative;
    cursor: pointer;

    .img {
      width: 100%;
      padding-top: 56.25%;
      position: relative;
      border-radius: 3px 3px 0px 0px;
      overflow: hidden;

      img {
        position: absolute;
        top: 0; left: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    .live-text {
      display: flex;
      align-items: center;
      height: 40px;
      justify-content: space-between;
      padding: 12px;
      box-sizing: border-box;

      .name {
        font-size: 12px;
        font-weight: 500;
        color: #333333;
        line-height: 18px;
        flex: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .num {
        font-size: 12px;
        font-weight: 400;
        color: #999999;
        line-height: 18px;
        flex-shrink: 0;
        margin-left: 4px;

        img {
          width: 12px;
          height: 12px;
        }
      }
    }

    .over-div {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      height: 100%;
      background: rgba(0, 0, 0, 0.4);
      border-radius: 3px 3px 0px 0px;

      img {
        width: 40px;
        height: 40px;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }
}

@media (max-width: 768px) {
  .live-content .live-div {
    width: calc((100% - 15px) / 2);
    min-width: unset;
  }
}
</style>
<script>
import LiveList from '../constant/live'
import TeenWelcomeBar from '../components/TeenWelcomeBar'

/** url 包含 /page/ 的项固定靠前 */
function isPageUrl(item) {
  return item && item.url && item.url.indexOf('/page/') !== -1
}

/** 外链直播页按账号追加 token（与 App.vue `setMinorModeByUsername` 的 xuanxuan 判定一致） */
function fisherYatesShuffle(arr) {
  const a = [...arr]
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    ;[a[i], a[j]] = [a[j], a[i]]
  }
  return a
}

export default {
  components: { TeenWelcomeBar },
  computed: {
    displayTagList() {
      // 青少年模式下不展示“演艺”，避免筛选后列表为空
      if (this.isTeenagerMode) return this.tagList.filter((x) => x && x.value !== '演艺')
      return this.tagList
    },
    filteredLiveList() {
      // 规则： url 包含 /page/ 的项固定靠前，音乐类再优先于其他 /page/ 项，其余随机
      const key = this.active || '__ALL__'
      if (this.shuffledByType[key]) return this.shuffledByType[key]

      const base = this.liveList.filter((item) => {
        const matchType = this.active === '' || item.type === this.active
        return matchType && item.cover
      })

      const pinned = base.filter((x) => isPageUrl(x))
      const rest = base.filter((x) => !isPageUrl(x))
      const pinnedMusic = pinned.filter((x) => x.type === '音乐')
      const pinnedOther = pinned.filter((x) => x.type !== '音乐')
      const shuffled = [
        ...fisherYatesShuffle(pinnedMusic),
        ...fisherYatesShuffle(pinnedOther),
        ...fisherYatesShuffle(rest),
      ]
      this.$set(this.shuffledByType, key, shuffled)
      return shuffled
    },
    pageTotal() {
      return this.filteredLiveList.length
    },
  },
  data() {
    return {
      isTeenagerMode: false,
      tagList: [
        { text: '演艺', value: '演艺' },
        { text: '音乐', value: '音乐' },
        { text: '体育', value: '体育' },
        { text: '科普', value: '科普' },
        { text: '百科', value: '百科' },
        { text: '其他', value: '其他' },
        { text: '全部', value: '' },
      ],
      active: '演艺',
      showPlay: '',
      liveList: [],
      shuffledByType: {},
      selectList: [],
      current: 1,
      size: 12,
    }
  },
  mounted() {
    this.initLiveListForAccount()
    if (localStorage.getItem('teenagerMode') === 'true') {
      this.$Message.info('青少年模式已开启，今日还可观看' + this.getRemainingTime())
    }
    if (this.$root && this.$root.$on) {
      this.$root.$on('account-changed', this.initLiveListForAccount)
    }
  },
  beforeDestroy() {
    if (this.$root && this.$root.$off) {
      this.$root.$off('account-changed', this.initLiveListForAccount)
    }
  },
  methods: {
    isTeenTimeExceeded() {
      if (localStorage.getItem('teenagerMode') !== 'true') return false
      const used = Number(localStorage.getItem('viewDuration')) || 0
      const remaining = 40 * 60 - used
      return remaining <= 0
    },
    getRemainingTime() {
      const used = Number(localStorage.getItem('viewDuration')) || 0
      const remaining = Math.max(40 * 60 - used, 0)
      const m = Math.floor(remaining / 60)
      const s = remaining % 60
      return m > 0 ? `${m}分钟${s > 0 ? s + '秒' : ''}` : `${s}秒`
    },
    initLiveListForAccount() {
      // 注意：不要直接改写 import 进来的 LiveList（它在多个页面间共享），否则随机/排序会被“固化”。
      let list = LiveList.map((item) => ({ ...item }))
      list.forEach((item) => {
        this.$set(
          item,
          'num',
          parseInt(Math.random() * (5000 - 100 + 1) + 100, 10)
        )
      })
      this.isTeenagerMode = localStorage.getItem('teenagerMode') === 'true'
      if (this.isTeenagerMode) {
        list = list.filter((item) => item.type !== '演艺')
      }
      this.liveList = list
      if (this.isTeenagerMode && this.active === '演艺') {
        // 默认不落在被过滤掉的类型上
        this.active = '音乐'
      }
      // 清空洗牌缓存，让首次进入/切换筛选时重新随机
      this.shuffledByType = {}
      this.handlePage(1)
    },
    isExternalLivePageUrl(url) {
      if (!url || typeof url !== 'string') return false
      return /^https?:\/\//i.test(url) && url.indexOf('/page/') !== -1
    },

    checkTag(val) {
      this.active = val
      // 切换类型时重新洗牌该类型，避免总是同一条在第一位
      const key = this.active || '__ALL__'
      if (this.shuffledByType && this.shuffledByType[key]) {
        this.$delete(this.shuffledByType, key)
      }
      this.handlePage(1)
    },
    appendTokenToExternalLiveUrl(url) {
      const token = localStorage.getItem('token') || ''
      const teenagerMode = localStorage.getItem('teenagerMode') === 'true'
      const sep = url.indexOf('?') === -1 ? '?' : '&'
      return `${url}${sep}token=${token}&teenagerMode=${teenagerMode}`
    },
    goLive(item) {
      if (!localStorage.getItem('token')) {
        this.$Message.warning('请先登录')
        this.$root.$emit('show-login')
        return
      }
      if (this.isTeenTimeExceeded()) {
        this.$root.$emit('teen-time-exceeded')
        return
      }
      if (this.isExternalLivePageUrl(item && item.url)) {
        window.location.href = this.appendTokenToExternalLiveUrl(item.url)
        return
      }
      sessionStorage.setItem('detail', JSON.stringify(item))
      sessionStorage.setItem('liveEnterFromClickAt', String(Date.now()))
      this.$router.push('/detail')
    },
    handlePage(page) {
      this.current = page
      const start = (this.current - 1) * this.size
      this.selectList = this.filteredLiveList.slice(start, start + this.size)
      this.$nextTick(() => {
        window.scrollTo(0, 0)
      })
    },
  },
}
</script>
